// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageMediumFragmentDoc } from '../imageMedium.fragment.generated';
import { LinkFragmentDoc } from '../index.generated';
export const LogoWithTextFragmentDoc = gql`
    fragment LogoWithText on LogoWithText {
  __typename
  title
  description
  image {
    ...imageMedium
  }
  logoLink: link {
    ...link
  }
}
    ${ImageMediumFragmentDoc}
${LinkFragmentDoc}`;
export const ComponentLogosWithTextFragmentDoc = gql`
    fragment ComponentLogosWithText on ComponentLogosWithText {
  __typename
  logos {
    ...LogoWithText
  }
}
    ${LogoWithTextFragmentDoc}`;